<template>
<div class="containers">
    <div v-if="goArea == true" class="area-list">
        <CAlert
        v-if="success == true"
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:rgba(48, 107, 221, 1);border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <CAlert
        v-else
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:red;border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <div class="search-area">
            <CRow>
                <CCol sm="5" class="pr-1">
                    <input type="text" placeholder="Perusahaan" v-model="searchPerusahaan" class="form-control"/>
                </CCol>
                <CCol sm="5" class="pr-1 pl-1">
                    <model-select style="background-color:rgba(249, 250, 252, 1)" :options="dataSearchTipe" class="form-control" v-model="searchTipe" placeholder="Tipe"></model-select>
                </CCol>
                <CCol sm="2">
                    <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
                </CCol>
            </CRow>
        </div>
        <div class="sticky1">
            <CRow>
                <CCol sm="6"></CCol>
                <CCol sm="6">
                    <span style="float:right">
                        <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                        <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    </span>
                    <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                    <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                    <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                    <img class="mt-1 mr-5" :src="moreIcon" width="20px" height="20px" style="float:right"/>
                    <img class="mr-5 mt-1" @click="reload()" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="float:right;cursor:pointer"/>
                </CCol>
            </CRow>
        </div>
        <Tables @sort="sorting" @edit="editData" :data="datas" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
    </div>
    <div v-else class="area-edit">
        <CRow class="area-back">
            <CCol sm="12">
                <img class="mt-2 mb-2" @click="moving()" :src="backIcon" width="20px" height="20px" style="float:left;cursor:pointer"/>
            </CCol>
        </CRow>
        <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
        <CRow class="area-input">
            <CCol sm="12">
                <CRow>
                    <CCol sm="6">
                        <label>Nama Perusahaan</label>
                        <input 
                            class="form-control" 
                            disabled
                            style="background-color:whitesmoke"
                            v-model="namaPerusahaan"
                            placeholder="Nama Perusahaan" 
                            type="text"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Tipe</label>
                        <model-select :options="dataTipe"
                            class="form-control model-select"
                            v-model.trim="$v.tipe.$model"
                            :class="{ 'is-invalid select-invalid':$v.tipe.$error, 'is-valid select-valid': !$v.tipe.$invalid }"
                            placeholder="Pilih Tipe">
                        </model-select>
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Harga {{tipe.text}}</label>
                        <input 
                            class="form-control mr-2" 
                            v-model.trim="$v.harga.$model"
                            @input="rupiahModeUangSaku()"
                            :class="{ 'is-invalid':$v.harga.$error, 'is-valid': !$v.harga.$invalid }"
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" 
                            placeholder="Harga"
                            type="text"
                        />
                    </CCol>
                    <CCol v-if="tipe.value == 'P'" sm="6">
                        <label>Maksimal Pegawai</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.maxPegawai.$model"
                            @input="changeRibuan()"
                            :class="{ 'is-invalid':$v.maxPegawai.$error, 'is-valid': !$v.maxPegawai.$invalid }"
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" 
                            placeholder="Maksimal Pegawai" 
                            type="text"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Nama Bank Billing</label>
                        <input 
                            class="form-control mr-2" 
                            v-model.trim="$v.namaBankBilling.$model"
                            :class="{ 'is-invalid':$v.namaBankBilling.$error, 'is-valid': !$v.namaBankBilling.$invalid }"
                            placeholder="Nama Bank"
                            type="text"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Nomor Rekening Billing</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.nomorRekeningBilling.$model"
                            :class="{ 'is-invalid':$v.nomorRekeningBilling.$error, 'is-valid': !$v.nomorRekeningBilling.$invalid }"
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" 
                            placeholder="Nomor Rekening" 
                            type="text"
                        />
                    </CCol>
                </CRow>
            </CCol>
        </CRow>
        <CRow class="area-button-submit">
            <CCol sm="12">
                <CButton @click="moving()" type="button" class="btn btn-cancel mr-2">Batal</CButton>
                <CButton @click="submitForm()" class="btn btn-edit-submit">
                    <span v-if="loading == false">Submit</span>
                    <CSpinner v-else color="default" size="sm"/>
                </CButton>
            </CCol>
        </CRow>
    </div>
</div>
</template>

<script>
import Tables from '../../../component/tableBilling'
import { DataApi } from "../../../service/DataApi";
import { ModelSelect } from 'vue-search-select'
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
export default {
    components: {
        ModelSelect,
        Tables
    },
    mixins: [validationMixin],
    validations: {
        tipe: {
            value: {
                required
            },
            text: {
                required
            }
        },
        maxPegawai: {
            required
        },
        harga: {
            required
        },
        namaBankBilling: {
            required
        },
        nomorRekeningBilling: {
            required
        }
    },
    data() {
        return {
            success: true,
            // datas
            refreshIcon: require('../../../assets/menu/icon_refresh.svg'),
            moreIcon: require('../../../assets/menu/icon_more.svg'),
            backIcon: require('../../../assets/menu/icon_goback.svg'),
            dataTh: ['Nama Perusahaan', 'Tanggal Expired', 'User', 'Harga', 'Tipe', 'Action'],
            dataTd: ['namaPerusahaan', 'tanggalExpired', 'maxPegawai', 'harga', 'tipeBilling', 'action'],
            styleTable: ['200px', '200px', '100px', '100px', '100px', '100px'],
            classReload: 'reloadOff',
            datas: [],
            goArea: true,
            loading: false,
            alertMess: '',
            currentAlertCounter: 0,

            // data model
            namaPerusahaan: '',
            kode: '',
            tipe: {
                value: '',
                text: ''
            },
            dataTipe: [],
            maxPegawai: '',
            harga: '',
            nomorRekeningBilling: '',
            namaBankBilling: '',

            // paging
            page: 1,
            size: 20,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,

            // filter
            searchPerusahaan: '',
            searchTipe: {
                text: '',
                value: ''
            },
            dataSearchTipe: [],
            // error
            errorMessage: '',
            flagSearch: false
        }
    },
    watch: {
        page() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        searchPerusahaan() {
            this.flagSearch = true
        },
        searchTipe() {
            this.flagSearch = true
        },
        goArea() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        tipe() {
            if(tipe.value == 'S') {
                this.maxPegawai = 0
            }
        }
    },
    computed: {
    },
    methods: {
        /**
         * GET DATA
         */
        sorting(value) {
            if(value == 0) {
                function compare(a,b) {
                    if (a.kode.toLowerCase() < b.kode.toLowerCase()) {
                        return -1
                    }
                    if (a.kode.toLowerCase() > b.kode.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 1) {
                function compare(a,b) {
                    if (a.keterangan.toLowerCase() < b.keterangan.toLowerCase()) {
                        return -1
                    }
                    if (a.keterangan.toLowerCase() > b.keterangan.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            }
        },
        getData() {
            if(this.flagSearch == true) {
                this.page = 1
            }
            this.$store.state.loadingScreen = true
            let payload = {
                limit: this.size,
                namaPerusahaan: this.searchPerusahaan,
                pageIn: this.page,
                tipeBilling: this.searchTipe.value
            }
            DataApi.post("billing/master/lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datas = response.data.data
                    this.totalRow = response.data.totalRow
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                } else {
                    this.datas = []
                    this.totalRow = 0
                    this.firstPage = 0
                    this.lastPage = 0
                    this.totalPage = 1
                    this.errorMessage = response.message
                }
                this.flagSearch = false
                this.$store.state.loadingScreen = false
            })
        },
        findData() {
            this.getData()
        },
        reload() {
            this.searchPerusahaan = ''
            this.searchTipe.value = ''
            this.searchTipe.text = ''
            this.dataSearchTipe = []
            this.getDataSearchTipe()
            this.flagSearch = true
            this.getData()
            if (this.classReload == 'reloadOff') {
                this.classReload = 'reloadOn'
            } else {
                this.classReload = 'reloadOff'
            }
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
            this.getData()
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        },

        /**
         * ADD DATA
         */
        moving() {
            setTimeout(this.moveArea, 600);
        },
        moveArea() {
            if(this.goArea == true) {
                this.goArea = false
            } else {
                this.goArea = true
                this.namaPerusahaan = ''
                this.harga = ''
                this.kode = ''
                this.maxPegawai = ''
                this.tipe.value = ''
                this.tipe.text = ''
                this.namaBankBilling = ''
                this.nomorRekeningBilling = ''
                this.dataTipe = []
                this.getDataTipe()
                this.$v.$reset()
            }
        },
        goSave() {
            let harga = ''
            let clear = ''
            if(this.harga[0] == 'R') {
                clear = this.harga.replace("Rp. ", '')
                var i
                for(i=0;i<clear.length;i++) {
                    if(clear[i] == '.') {
                        //
                    } else {
                        harga += clear[i]
                    }
                }
            } else {
                harga = this.harga
            }

            let maxPegawai = ''
            let clears = this.maxPegawai
            var j
            for(j=0;j<clears.length;j++) {
                if(clears[j] == '.') {
                    //
                } else {
                    maxPegawai += clears[j]
                }
            }
            let payload = {
                harga: harga,
                kode: this.kode,
                maxPegawai: maxPegawai,
                namaBankBilling: this.namaBankBilling,
                noRekBilling: this.nomorRekeningBilling,
                tipeBilling: this.tipe.value
            }
            DataApi.post("billing/master/simpan", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        this.success = true
                    } else {
                        this.success = false
                    }
                    this.alertMess = response.data.Data2
                } else {
                    this.alertMess = response.message
                    this.success = false
                }
                this.getData()
                this.moving()
                this.loading = false
                this.currentAlertCounter = 7
            })
        },

        /**
         * EDIT DATA
         */
        editData(value) {
            let generate = this.datas[value]
            this.kode = generate.kode
            this.namaPerusahaan = generate.namaPerusahaan
            this.maxPegawai = generate.maxPegawai
            
            this.harga = generate.harga
            this.namaBankBilling = generate.namaBankBilling
            this.nomorRekeningBilling = generate.noRekBilling

            let data = this.dataTipe
            let tipe = generate.tipeBilling
            this.rupiahModeUangSaku()
            this.changeRibuan()
            var i = 0
            for(i=0;i<data.length;i++) {
                if(tipe == data[i].text) {
                    this.tipe.value = data[i].value
                    this.tipe.text = data[i].text
                }
            }
            this.moving()
        },
        submitForm() {
            this.$v.$touch()
            if(this.$v.$invalid) {
                if(this.tipe.value == 'S') {
                    if(this.$v.maxPegawai.$invalid) {
                        this.goSave()
                        this.loading = true
                    }
                }
            } else {
                this.goSave()
                this.loading = true
            }
        },
        getDataSearchTipe() {
            this.dataSearchTipe = [
                { value: '', text: 'Semua'},
                { value: 'S', text: 'Satuan'},
                { value: 'P', text: 'Paket'}
            ]
        },
        getDataTipe() {
            this.dataTipe = [
                { value: 'S', text: 'Satuan'},
                { value: 'P', text: 'Paket'}
            ]
        },
        rupiahModeUangSaku() {
            let angka = this.harga
            var number_string = angka.toString().replace(/[^,\d]/g, '')
            var split           = number_string.split(',')
            var sisa             = split[0].length % 3
            var rupiah             = split[0].substr(0, sisa)
            var ribuan             = split[0].substr(sisa).match(/\d{3}/gi)
            var prefix = "Rp. "
        
            // tambahkan titik jika yang di input sudah menjadi angka satuan ribuan
            if(ribuan){
                var separator = sisa ? '.' : '';
                rupiah += separator + ribuan.join('.');
            }
        
            rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
            let hasil = prefix == undefined ? rupiah : (rupiah ? 'Rp. ' + rupiah : '');
            this.harga = hasil
        },
        changeRibuan() {
            let angka = this.maxPegawai
            var number_string = angka.toString().replace(/[^,\d]/g, '')
            var split           = number_string.split(',')
            var sisa             = split[0].length % 3
            var rupiah             = split[0].substr(0, sisa)
            var ribuan             = split[0].substr(sisa).match(/\d{3}/gi)
        
            // tambahkan titik jika yang di input sudah menjadi angka satuan ribuan
            if(ribuan){
                var separator = sisa ? '.' : '';
                rupiah += separator + ribuan.join('.');
            }

            this.maxPegawai = rupiah
        }
    },
    mounted() {
        this.errorMessage = 'Find Your Data'
        this.getDataSearchTipe()
        this.getDataTipe()
    }
}
</script>
<style scoped>
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
.autocomplete {
    width: 100%;
    position: relative;
}
.input {
    cursor: text;
}
.close {
    position: absolute;
    right: 8px;
    top: 10px;
    background: none;
    border: none;
    font-size: 14px;
    color: lightgrey;
    cursor: pointer;
}
.placeholder {
    position: absolute;
    top: 7px;
    left: 16px;
    font-size: 14px;
    color: #d0d0d0;
}
.popovers {
    text-align: center;
    width: 100% !important;
    min-height: 50px;
    border: 1px solid #d8dbe0;
    position: absolute;
    top: 35px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    text-align: center;
    z-index: 3;
}
.popovers input {
    right: 8px;
    left: 8px;
    width: 100%;
}
.options {
    max-height: 200px;
    overflow-y: auto;
    margin-top: 5px;
}
.options ul {
    list-style-type: none;
    text-align: left;
    padding-left: 0;
}
.options ul li {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    cursor: pointer;
    background: white;
}
.options ul li:first-child {
    border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.btn-search {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}

.btn-add {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-add:hover {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.btn-cancel {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-cancel:hover {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(-180deg);
    transition: 300ms linear all;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(180deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 6px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding-top: 6px;
    padding-right: 20px;
    padding-left: 20px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
input {
    background-color: rgba(249, 250, 252, 1);
}

.area-edit {
    background-color: white;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
}
.area-back {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input label {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
    font-weight: 600;
    margin-bottom: 12px;
}
.area-input input, .area-input .model-select {
    background-color: white;
    margin-bottom: 20px;
}
.area-button-submit {
    padding-left: 20px;
    padding-bottom: 20px;
    padding-top: 32px;
}
.select-invalid {
    border: 1px solid #e55353 !important;
}
.select-valid {
    border: 1px solid #2eb85c !important;
}
.btn-edit-submit {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
    font-size: 14px;
}
.cards-image {
    position: absolute;
    text-align: center;
    font-size: 27px;
    color: rgba(96, 96, 96, 1);
    line-height: 50px;
    border: 1px dotted rgba(221, 221, 221, 1);
    width: 56px !important;
    background-color: rgba(250, 250, 250, 1);
    height: 56px !important;
}
input[type="checkbox"] {
    width: 16px;
    height: 16px;
    margin-right: 8px;
}
</style>
